export default {
      id: "lock-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "icons/mvm-icons.svg#lock",
      toString: function () {
        return this.url;
      }
    }